var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loader_spinner",attrs:{"role":"loader"}},[_c('div',{staticClass:"opacity_background"}),_vm._v(" "),_c('span',{class:_vm.loader_style_class})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }